export default __webpack_public_path__ + "static/media/testimonial-1.3e72fb90.png";